(() => {
  const HALLS = {
    TEST: {
      DANCE: 645,
      KOHL: 670,
      THAYER: 647,
      ZIPPER: 648,
    },
    LIVE: {
      DANCE: 645,
      KOHL: 670,
      THAYER: 647,
      ZIPPER: 648,
    },
  };

  const MESSAGES = {
    KOHL: "By naming seats in Terri and Jerry Kohl Hall, you are making a historic contribution toward the future of the Colburn School. Please consider your preferred donor name/quote for your seat(s), limit of 40 characters, and submit your dedication here:",
    ZIPPER:
      "By naming seats in Zipper Hall, you are making a historic contribution toward the future of the Colburn School. Please consider your preferred donor name/quote for your seat(s), limit of 40 characters, and submit your dedication here:",
    THAYER:
      "By naming seats in Thayer Hall, you are making a historic contribution toward the future of the Colburn School. Please consider your preferred donor name/quote for your seat(s), limit of 40 characters, and submit your dedication here:",
    DANCE:
      "By naming seats in the Dance Studio Theater, you are making a historic contribution toward the future of the Colburn School. Please consider your preferred donor name/quote for your seat(s), limit of 40 characters, and submit your dedication here:",
  };

  const isTestSite = () => {
    return window.location.href.includes("tnhs.cloud");
  };

  const onReceiptPage = () => {
    return window.location.href.includes("cart/receipt");
  };

  const hallData = () => {
    const ENV = isTestSite() ? "TEST" : "LIVE";
    return HALLS[ENV];
  };

  const bannerMessage = (performanceId) => {
    const halls = hallData();
    for (const hall in halls) {
      if (performanceId === halls[hall]) {
        return MESSAGES[hall];
      }
    }
    return MESSAGES.deafult;
  };

  const bannerHTML = (orderId, performanceId) => {
    const subdomain = isTestSite() ? "test." : "";
    const url = `https://${subdomain}yourseat.colburnschool.edu/orders/${orderId}/`;
    const message = bannerMessage(performanceId);

    return `<div class="seat-dedications">
        <h5 class="seat-dedications__title">Thank You</h5>
        <p class="seat-dedications__intro">${message}</p>
        <a class="seat-dedications__btn" href="${url}">Provide your dedications</a>
        </div>`;
  };

  document.addEventListener("DOMContentLoaded", () => {
    if (onReceiptPage()) {
      const performances = [];
      const halls = hallData();

      for (const hall in halls) {
        performances.push(halls[hall]);
      }

      for (const id of performances) {
        const parent = document.querySelector(`[data-tn-performance="${id}"]`);
        if (parent) {
          const orderId = document
            .querySelector(".tn-order-information-line.tn-order-number")
            .outerText.replace("Order Number: ", "")
            .trim();
          parent.insertAdjacentHTML("beforeend", bannerHTML(orderId, id));
          parent.style.display = "flow-root";
          const toHide = document.querySelector(
            `[data-tn-performance="${id}"] .tn-cart-item-mobile-ticket__container`,
          );
          toHide.style.display = "none";
        }
      }
    }
  });
})();
